import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const get_files_list_no = (name, status) => {
  return api.post(`${ApiEndpointConstants.GETMODELLISTNO}`, {
    page: 1,
    per_page: 10,
    name,
    status,
  });
};
